import { User } from '../store/user/user.types';

export function isSuperUser(globalRoles?: string[]): boolean {
  return (globalRoles ?? []).includes('SUPER_USER');
}

export function isSuperUserOrDeveloper(globalRoles?: string[]): boolean {
  return (globalRoles ?? []).some((globalRole) => ['DEVELOPER', 'SUPER_USER'].includes(globalRole));
}

export function isServiceProviderSupportUser(user: User): boolean {
  return user.serviceProviders.some((sp) => sp.role === 'SUPPORT');
}
